export const newFeatures = {
    collection: {
        level: '레벨',
        fix_time: '수리 횟수:',
        earn_exercise: '운동 당 획득한 보상:',
        on_selling: '판매 중',
        sell: '판매',
        edit: '편집',
        buy: '구매',
        stop: '중지',
        cancel: '취소',
        update: '업데이트',
        search: '검색',
    },
    sort_filter: {
        sort_by: '정렬 기준',
        filter: '필터',
        status: '상태',
        sell_in: '에서 판매',
        class: '등급',
        sale_hight: '최근 판매',
        sale_low: '오래된 순',
        level_hight: '레벨: 높은 순',
        level_low: '레벨: 낮은 순',
        reward_hight: '보상: 높은 순',
        reward_low: '보상: 낮은 순',
        fix_time_hight: '수리 횟수: 높은 순',
        fix_time_low: '수리 횟수: 낮은 순',
        radio_1: '돈을 벌 준비가',
        radio_2: '수리 필요',
        radio_3: '판매 중',
        clear_all: '모두 지우기',
    },
    modal_sell: {
        fee: '판매 주문이 성공하면 %{fee} ( ~%{value})를 가치의 일부로 받게됩니다.',
        sell_nft: 'NFT 판매',
        edit_nft: 'NFT 편집',
        buy_Nft: 'NFT 구매',
        stop_sell: '판매 중지',
        want_sell_in: '나는 여기서 판매하려고 합니다',
        want_buy: '이 NFT를 구매하시겠습니까?',
        want_stop: '판매 중지하시겠습니까?',
        code_2fa: '2FA 코드',
    },
    tab_leaf: {
        payment: '결제',
        total_amount: '총 금액',
        quantity: '수량',
        pay: '결제',
        balance: '잔액',
        limitMessage: '현재 잔액이 충분하지 않습니다!',
        you_have: '보유 수량:',
        leaf: ' 리프',
    },
    transaction: {
        transaction_history: '거래 내역',
        type: '유형',
        item_id: '아이템 ID',
        tier: '티어',
        level: '레벨',
        price: '가격',
        token: '토큰',
        seller_buyer: '판매자/구매자',
        time: '시간',
        filter: '필터링',
        send: '보내다',
    },
    common: {
        price: '가격',
        noData_market: '검색 결과에 해당하는 NFT가 없습니다.',
        edit: '수정',
        no_transaction: '어떠한 거래도 없습니다.',
        all: '전체',
        buy: '구매',
        sell: '판매',
        sent: '송신',
        receive: '수신',
        connect: '연결',
        amount: '양 ',
        leaves: '잎  ',



    },
    tab_ticket: {
        ticket: ' 티켓'
    },
};
